(function paycheckRRHHFindControllerDefinition() {
    'use strict';

    angular.module('PaycheckRRHH')
        .controller('PaycheckRRHHFindController', [
            '$q', '$filter', '$scope', '$state', 'errorsExtend', 'processService', 'configViewService', 'authExtend', '$translate', 'storageService', 'fileWorkflowService', 'fileDownloader', 'alerts','organizationalUnitService',
            function paycheckRRHHFindController($q, $filter, $scope, $state, errors, processService, configViewService, auth, $translate, storageService, fileWorkflowService, fileDownloader, alerts, organizationalUnitService) {

                $translate(['PaginationNext', 'PaginationPrev', 'PaginationFirstFem', 'PaginationLastFem'])
                    .then(function (translated) {
                        $scope.paginatorTranslations = {
                            nextText: translated.PaginationNext,
                            previousText: translated.PaginationPrev,
                            lastText: translated.PaginationLastFem,
                            firstText: translated.PaginationFirstFem
                        };
                    });

                $scope.accordionState = {
                    isOpen: true
                };

                if ($state.params.isSignPending) {
                    $scope.legend = { type: 'warning', message: 'PayCheckSignPending' }
                }

                $scope.createFilters = function () {
                    var idOu = $scope.find.organizationalUnit ? $scope.find.organizationalUnit.id : undefined;

                    var filters = {
                        name: $scope.find.name,
                        processTypeId: $scope.find.processType.id,
                        organizationalUnitId: idOu,
                        processStatesIds: [],
                        metadatas: [],
                        dateFrom: $scope.find.dateFrom,
                        dateTo: $scope.find.dateTo,
                        viewedDateFrom: $scope.find.viewedDateFrom,
                        viewedDateTo: $scope.find.viewedDateTo,
                        itemPerPage: $scope.data.itemPerPage,
                        page: $scope.data.currentPage
                    };

                    $scope.find.showNoData = false;

                    $scope.find.processType.metadatas.forEach(function (meta) {
                        filters.metadatas.push(meta);
                    });

                    if ($scope.find.selectedStates && $scope.find.selectedStates.length > 0) {
                        $scope.find.selectedStates.forEach(function (state) {
                            filters.processStatesIds = filters.processStatesIds.concat(state.ids);
                        });
                    } else {
                        $scope.find.processType.states.forEach(function (state) {
                            filters.processStatesIds = filters.processStatesIds.concat(state.ids);
                        });
                    }

                    return filters;
                };

                $scope.executeFind = function () {
                    var filters = $scope.createFilters();
                    $scope.loadActions();

                    return processService.advancedGet(filters).then(function (result) {
                        $scope.paychecks = [];
                        $scope.data.totalItems = result.count;
                        $scope.data.from = 1 + ($scope.data.itemPerPage * ($scope.data.currentPage - 1));
                        result.values.forEach(function (value) {
                            var r = value;
                            r.metadatas = [];
                            var found = $scope.find.processType.headers.find(function (item) { return item.systemName === '_modFirma' });
                            var index = $scope.find.processType.headers.indexOf(found);
                            if (index > -1) {
                                $scope.find.processType.headers.splice(index, 1);
                            }
                            $scope.find.processType.headers.forEach(function (header) {
                                var metadataFound = $filter('filter')(value.metadataValues, { systemName: header.systemName }, true);
                                if (metadataFound && metadataFound.length != 0) {
                                    var metadataDescription = metadataFound[0].value;            
                                    filters.metadatas.forEach(function (value) {
                                        var metadataOptionFound = $filter('filter')(value.metadataOptions, { value: metadataFound[0].value }, true);
                                        if (metadataOptionFound && metadataOptionFound.length != 0) {
                                            metadataDescription = metadataOptionFound[0].description;
                                        }
                                    });
                                        r.metadatas.push({ value: metadataDescription, type: metadataFound[0].type, mask: header.mask });                                                                        
                                } else {
                                    r.metadatas.push({ value: null, type: null, mask: null });
                                }
                            });

                            $scope.paychecks.push(r);
                        });

                        if ($scope.paychecks.length == 0) {
                            $scope.find.showNoData = true;
                        }

                        if ($scope.paychecks.length > 0) {
                            $scope.accordionState.isOpen = false;
                            $scope.find.showResult = true;
                            $scope.fillAccordion();
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.findAction = function () {
                    if (!$scope.paycheckRRHHFind.$valid) {
                        $scope.paycheckRRHHFind.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    storageService.setPaychecksRrhhFilter($scope.find);

                    return $scope.executeFind();
                };

                $scope.add = function () {
                    $state.go('paycheck-rrhh-add');
                };

                $scope.statistics = function () {
                    $state.go('statistics-rrhh-find');
                };

                $scope.view = function (payc) {
                    $state.go('paycheck-rrhh-detail', { id: payc.id });
                };

                $scope.loadPreFilters = function () {
                    if (!$scope.find.processType) {
                        var found = $filter('filter')($scope.processTypes, { preSelected: true }, true);
                        $scope.find.processType = angular.copy(found[0] || $scope.processTypes[0]);
                    }
                    var found = $scope.find.processType.metadatas.find(function (item) { return item.metadataSystemName === '_modFirma' });
                    var index = $scope.find.processType.metadatas.indexOf(found);
                    if (index > -1) {
                        $scope.find.processType.metadatas.splice(index, 1);
                    }
                    if ($scope.find.selectedStates.length === 0) {
                        $scope.find.selectedStates = $filter('filter')($scope.find.processType.states, { preSelected: true }, true);
                    }
                };

                $scope.cleanFilters = function () {
                    $scope.accordionState.isOpen = true;

                    storageService.clearPaychecksRrhhFilter();

                    $scope.find = storageService.getPaychecksRrhhFilter();
                    $scope.paychecks = [];

                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 50,
                        from: 0
                    }

                    $scope.actions = {
                        delete: false,
                        edit: false
                    };

                    $scope.loadPreFilters();
                    angular.forEach($scope.processTypes, function (item) {
                        if (item.id === $scope.find.processType.id) {
                            $scope.find.processType.metadatas = angular.copy(item.metadatas);
                        }
                    });
                };

                $scope.fillAccordion = function () {
                    $scope.paychecks.forEach(function (paycheck) {
                        var accordionIsOpen = false;
                        Object.defineProperty(paycheck, "accordionIsOpen", {
                            get: function () { return accordionIsOpen; },
                            set: function (newValue) {
                                if (event.target.id !== "options" && !(event.target.offsetParent !== null && event.target.offsetParent.id === "options")) {
                                    if (event.target.offsetParent !== null && event.target.offsetParent.offsetParent.id === "p") {
                                        accordionIsOpen = newValue;
                                    }
                                }
                            }
                        });
                    });
                };

                $scope.selectProcessType = function (processType) {
                    $scope.find.processType = angular.copy(processType);
                    $scope.paychecks = [];
                    $scope.find.showResult = false;
                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 50,
                        from: 0
                    }

                    $scope.actions = {
                        delete: false,
                        edit: false
                    };

                    $scope.loadPreFilters();
                };

                $scope.loadMetadata = function (item) {
                    var processType = {
                        name: item.name,
                        id: item.processTypeId,
                        preSelected: item.preSelected,
                        states: item.groupStates,
                        metadatas: [],
                        headers: []
                    };

                    item.metadatas.forEach(function (metadata) {

                        if (metadata.searchCriteria) {
                            var data = 
                            {
                                idObject: item.name.replace(/ /g, '_') + metadata.systemName,
                                metadataId: metadata.metadataId,
                                metadataValueFrom: undefined,
                                metadataValueTo: undefined,
                                metadataSearchTypeFrom: undefined,
                                metadataSearchTypeTo: undefined,
                                metadataType: metadata.metadataType != null ? metadata.metadataType.toLowerCase() : undefined,
                                metadataSystemName: metadata.systemName,
                                metadataLabel: metadata.searchCriteria.name,
                                metadataReadOnly: !metadata.searchCriteria.isEditable,
                                metadataEnabled: true,
                                metadataOptions: metadata.metadataOptionValues,
                                maskOptions: metadata.metadataMaskOption,
                                order: metadata.searchCriteria.order
                            };


                            if (metadata.systemName === '_trec') {
                                if ($scope.paycheckConfig && $scope.paycheckConfig['#PaycheckTypeOptions']) {
                                    var docTypes = $scope.paycheckConfig['#PaycheckTypeOptions'].split(',');
                                    data.metadataOptions = data.metadataOptions.filter(function (i) {
                                        return docTypes.indexOf(i.value) >= 0;
                                    });
                                }
                            }

                            processType.metadatas.push(data);

                        }

                        if (metadata.resultCriteria) {
                            processType.headers.push({ label: metadata.resultCriteria.name, systemName: metadata.systemName, order: metadata.resultCriteria.order, mask: metadata.resultCriteria.mask });
                        }
                    });

                    processType.metadatas.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    processType.headers.sort(function (a, b) {
                        return a.order - b.order;
                    })

                    processType.states.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    $scope.processTypes.push(processType);
                };

                //$scope.loadViewOptions = function () {
                //    var defered = $q.defer();
                //    var promise = defered.promise;

                //    if ($scope.processTypes && $scope.processTypes.length > 0) {
                //        defered.resolve();
                //    } else {
                //        configViewService.getById("CPPPaycheckRRHH").then(function (result) {
                //            if (result.processTypes && result.processTypes.length > 0) {
                //                $scope.processTypes = [];
                //                angular.forEach(result.processTypes, function (item) {
                //                    $scope.loadMetadata(item);
                //                });
                //            }

                //            defered.resolve();
                //        }, function (error) {
                //            errors.showError(error);
                //            defered.reject();
                //        });
                //    }

                //    return promise;
                //};

                $scope.loadViewOptions = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    if (!$scope.processTypes || $scope.processTypes.length < 1) {

                        $q.all([configViewService.getById("CPPPaycheckRRHH"),
                        organizationalUnitService.getConfig(auth.getOrganizationId(), '#OuConfigRSD')]).then(function (results) {

                            if (results[0].processTypes && results[0].processTypes.length > 0) {
                                $scope.paycheckConfig = results[1];
                                $scope.processTypes = [];
                                angular.forEach(results[0].processTypes, function (item) {
                                    $scope.loadMetadata(item);
                                });
                                var found = $filter('filter')($scope.processTypes, { preSelected: true }, true);
                                $scope.processType = found[0] || $scope.processTypes[0];
                            }

                            defered.resolve();
                        }, function (error) {
                            errors.showError(error);
                            defered.reject();
                        });
                    } else {
                        defered.resolve();
                    }

                    return promise;
                };


                $scope.downloadAllFiles = function () {
                    var filters = $scope.createFilters();
                    filters.itemPerPage = null;
                    filters.page = null;

                    return processService.advancedGet(filters).then(function (result) {
                        var files = [];
                        var paychecks = result.values;

                        paychecks.forEach(function (paycheck) {
                            if (paycheck.files.length > 0) {
                                var mvs = paycheck.metadataValues.map(function (mv) {
                                    switch (mv.systemName) {
                                        case '_nroleg':
                                        case '_peri':
                                        case '_trec':
                                            return mv.value;
                                    }
                                }).filter(function (mv) { return mv });

                                files.push({
                                    id: paycheck.files[0].id,
                                    name: (mvs.length == 3 ? mvs[2] + ' - ' : '') + mvs[0] + ' - ' + mvs[1] + ' - ' + paycheck.stateAlias + ' [' + paycheck.files[0].creationDate.replace(/:/g, '.') + '].pdf'
                                });
                            }
                        });

                        return fileWorkflowService.downloadFilesIntoZip(files).then(function (result) {

                            var success = fileDownloader.saveAs(result.value, $translate.instant('PaycheckAllFiles') + '.zip');

                            if (!success) {
                                errors.showError('Api failed');
                            }

                        }, function (error) {
                            if (error.status === 204) {
                                errors.showWarning('The document has no files');
                            } else {
                                errors.showError('Api failed');
                            }
                        });
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.downloadFile = function (paycheck) {
                    var file = paycheck.files[0];
                    var metadata = {
                        nrolegValue: '',
                        periValue: '',
                        trecValue: ''
                    };

                    for (var i = 0; i < paycheck.metadataValues.length; i++) {
                        switch (paycheck.metadataValues[i].systemName) {
                            case '_nroleg': metadata.nrolegValue = paycheck.metadataValues[i].value; break;
                            case '_peri': metadata.periValue = paycheck.metadataValues[i].value; break;
                            case '_trec': metadata.trecValue = paycheck.metadataValues[i].value; break;
                        }
                    }
                    return fileWorkflowService.downloadFile(file.id).then(function (result) {
                        var fileName = metadata.nrolegValue + ' - ' + metadata.periValue + ' - ' + metadata.trecValue + ' - ' + paycheck.stateAlias + ' [' + paycheck.files[0].creationDate.replace(/:/g, '.') + '].pdf';
                        var success = fileDownloader.saveAs(result, fileName);

                        if (!success) {
                            errors.showError('Api failed');
                        }

                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError('Api failed');
                        }
                    });
                };

                $scope.exportToExcel = function () {
                    return $translate(['DocumentOrganizationalUnits', 'ProcessReceptionDateView', 'ProcessState', 'User', 'ProcessName'])
                        .then(function (translated) {
                            var headers = [];

                            var filters = $scope.createFilters();

                            filters.itemPerPage = null;
                            filters.page = null;

                            headers.push({ key: "OrganizationalUnitName", value: translated.DocumentOrganizationalUnits });
                            headers.push({ key: "CreationDate", value: translated.ProcessReceptionDateView });

                            $scope.find.processType.headers.forEach(function (header) {
                                headers.push({ key: header.systemName, value: header.label });
                            });

                            headers.push({ key: "StateAlias", value: translated.ProcessState });
                            headers.push({ key: "Name", value: translated.ProcessName });

                            return processService.exportToXLS(filters, headers, 'Recibos').then(function (result) {
                                var d = new Date();

                                var docName = "Recibos";

                                var success = fileDownloader.saveAs(result.value, docName +
                                    '_' +
                                    d.getUTCFullYear() +
                                    '-' +
                                    (d.getUTCMonth() + 1) +
                                    '-' +
                                    d.getDate() +
                                    '.xlsx');

                                if (!success) {
                                    errors.showError('Api failed');
                                }

                            }, function (error) {
                                if (error.status === 403) {
                                    errors.showError('FileForbidden');
                                } else {
                                    errors.showError('Api failed');
                                }
                            });
                        });
                };

                $scope.checkUnCheckAll = function () {
                    if ($scope.paychecks.length > 0) {
                        $scope.paychecks.forEach(function (pc) {
                            pc.check = $scope.checkAll;
                        });
                    }
                };

                $scope.sign = function () {
                    var toSign = [];

                    $scope.paychecks.forEach(function (paycheck) {
                        if (paycheck.check) {
                            toSign.push(paycheck);
                        }
                    });

                    if (toSign.length == 0) {
                        errors.showWarning('SignNoProcess');
                    } else {
                        processService.setSignProcesses(toSign);
                        $state.go('paycheck-rrhh-sign');
                    }
                };

                $scope.signAll = function () {
                    var toSign = [];

                    var filters = $scope.createFilters();
                    filters.itemPerPage = 0;
                    filters.page = 1;

                    return processService.advancedGet(filters).then(function (result) {
                        toSign = result.values;
                        if (toSign.length == 0) {
                            errors.showError('SignNoProcess');
                        } else {
                            processService.setSignProcesses(toSign);
                            $state.go('paycheck-rrhh-sign');
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.delete = function () {
                    var toDelete = [];

                    $scope.paychecks.forEach(function (paycheck) {
                        if (paycheck.check) {
                            toDelete.push(paycheck.id);
                        }
                    });

                    if (toDelete.length == 0) {
                        return errors.showWarning('DeleteNoProcess');
                    } else {
                        return $translate(['Warning', 'DeleteMultiplePaycheckConfirmText', 'Yes', 'No']).then(function (translated) {
                            return alerts.confirm(translated.Warning, translated.DeleteMultiplePaycheckConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                                if (result) {
                                    $scope.loading = true;

                                    processService.deleteBatch(toDelete).then(function (resultCount) {
                                        var success = {
                                            data: {
                                                key: 'DeleteMultipleSucces',
                                                value: { processesCount: resultCount, from: toDelete.length }
                                            }
                                        }
                                        errors.showSuccess(success);
                                        $scope.loading = false;
                                        $scope.load();
                                    }, function (error) {
                                        $scope.loading = false;
                                        errors.showError(error);
                                    });;
                                } else {
                                    $scope.loading = false;
                                }
                            });
                        });
                    }
                };

                $scope.deleteAll = function () {
                    var toDelete = [];
                    var filters = $scope.createFilters();
                    filters.itemPerPage = 0;
                    filters.page = 1;

                    return processService.advancedGet(filters).then(function (result) {
                        result.values.forEach(function (paycheck) {
                            toDelete.push(paycheck.id);
                        });

                        if (toDelete.length == 0) {
                            return errors.showError('DeleteNoProcess');
                        } else {
                            return $translate(['Warning', 'DeleteMultiplePaycheckConfirmText', 'Yes', 'No']).then(function (translated) {
                                return alerts.confirm(translated.Warning, translated.DeleteMultiplePaycheckConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                                    if (result) {
                                        $scope.loading = true;

                                        processService.deleteBatch(toDelete).then(function (resultCount) {
                                            var success = {
                                                data: {
                                                    key: 'DeleteMultipleSucces',
                                                    value: { processesCount: resultCount, from: toDelete.length }
                                                }
                                            }
                                            errors.showSuccess(success);
                                            $scope.loading = false;
                                            $scope.load();
                                        }, function (error) {
                                            $scope.loading = false;
                                            errors.showError(error);
                                        });;
                                    } else {
                                        $scope.loading = false;
                                    }
                                });
                            });
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.loadActions = function () {
                    $scope.actions = {
                        delete: false,
                        edit: false
                    };

                    if ($scope.find.selectedStates && $scope.find.selectedStates.length > 0) {
                        var bDelete = $scope.find.selectedStates.every(function (item) {
                            return item.delete;
                        });

                        var bEdit = $scope.find.selectedStates.every(function (item) {
                            return item.edit;
                        });

                        $scope.actions = {
                            delete: bDelete,
                            edit: bEdit,
                            editName: 'PaycheckRRHH' + $scope.find.selectedStates[0].editName,
                            editNameAll: 'PaycheckRRHH' + $scope.find.selectedStates[0].editName + 'All'
                        };
                    }
                };

                $scope.load = function () {
                    $scope.organizationalUnitId = 0;
                    $scope.paycheckConfig = {};

                    $scope.loading = false;
                    $scope.checkAll = false;

                    $scope.actions = {
                        delete: false,
                        edit: false
                    };

                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 50,
                        from: 0
                    };

                    $scope.writePermission = auth.isInRole('PAYCHECK WRITE');
                    $scope.signPermission = auth.isInRole('PAYCHECK SIGN');
                    $scope.signAllPermission = auth.isInRole('PAYCHECK MULTIPLE SIGN');
                    $scope.deletePermission = auth.isInRole('PAYCHECK DELETE');
                    $scope.deleteAllPermission = auth.isInRole('PAYCHECK MULTIPLE DELETE');
                    $scope.cancelAllPermission = auth.isInRole('PAYCHECK MULTIPLE CANCEL');
                    $scope.find = storageService.getPaychecksRrhhFilter();

                    $scope.loadViewOptions().then(function () {
                        $scope.loadPreFilters();
                        $scope.executeFind();
                    });
                };

                $scope.load();

            }]);
})();